import React, { useEffect, useState } from "react";
import "../../global.css";
import "./aboutUs.css";
import { useMediaQuery } from "react-responsive";
import { setContent } from "../../redux/contentSlice";
import { setFollowMouse } from "../../redux/followMouseSlice";
import { useSelector, useDispatch } from "react-redux";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import ContentCard from "../../components/contentcard/ContentCard";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../utils/useTranslate";

const AboutUs = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [isOpenModal, setIsOpenModal] = useState(false);

  const { language } = useSelector((state) => state.language);
  const { isOpenContentsModal } = useSelector((state) => state.content);

  useEffect(() => {
    dispatch(setContent(null));
  }, [dispatch]);

  const [about, setAbout] = useState(null);

  const [contents, setContents] = useState([]);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    } else {
      fetch("/assets/datas/tr-contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    }
  }, [language]);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/about.json")
        .then((res) => res.json())
        .then((data) => {
          setAbout(data);
        });
    } else {
      fetch("/assets/datas/tr-about.json")
        .then((res) => res.json())
        .then((data) => {
          setAbout(data);
        });
    }
  }, [language]);

  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = () => {
    setShowTooltip(true);
    dispatch(setFollowMouse(false));
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
    dispatch(setFollowMouse(true));
  };

  const handleMouseMove = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
  };

  return (
    <div className="globalContainer aboutUsContainer">
      <div
        className="aboutUsLeftContainer"
        style={{
          width: isOpenContentsModal === false && isMobile === false && "96%",
        }}
      >
        <div className="aboutUsLeftSubContainer">
          <div className="aboutUsLeftSubAltContainer">
            <span className="textFlex aboutUsTitleStyle">
              {language.value === "tr"
                ? translate("aboutUs").toLocaleUpperCase("tr-TR")
                : translate("aboutUs").toLocaleUpperCase("en-US")}
            </span>
          </div>
          <span className="textFlex aboutUsDescriptionStyle">
            {about?.aboutUs}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: isMobile === false ? "row" : "column",
            width:
              isMobile === false && isOpenContentsModal === false
                ? "100%"
                : "98%",
            gap: isMobile === false ? "10px" : "20px",
            marginTop: "50px",
          }}
        >
          <div
            style={{
              width: isMobile === false ? "35%" : "96%",
              backgroundColor: "#474747",
              padding: isMobile === false ? "20px" : "10px",
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              gap: "10px",
              border: "1px solid #100F0D",
              borderRadius: "8px",
            }}
          >
            <span
              className="textFlex"
              style={{ fontWeight: "600", fontSize: "24px", color: "#EF4536" }}
            >
              {language.value === "tr"
                ? translate("whatWeDo").toLocaleUpperCase("tr-TR")
                : translate("whatWeDo").toLocaleUpperCase("en-US")}
            </span>
            <span
              className="textFlex"
              style={{ fontWeight: "400", fontSize: "16px", color: "white" }}
            >
              {about?.whatWeDo.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
          <div
            style={{
              width: isMobile === false ? "65%" : "96%",
              backgroundColor: "#cc727a",
              padding: isMobile === false ? "20px" : "10px",
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              gap: "10px",
              border: "1px solid #100F0D",
              borderRadius: "8px",
            }}
          >
            <span
              className="textFlex"
              style={{ fontWeight: "600", fontSize: "24px", color: "white" }}
            >
              {language.value === "tr"
                ? translate("researchAndInnovation").toLocaleUpperCase("tr-TR")
                : translate("researchAndInnovation").toLocaleUpperCase("en-US")}
            </span>
            <span
              className="textFlex"
              style={{ fontWeight: "400", fontSize: "16px", color: "#100F0D" }}
            >
              {about?.researchAndInnovation.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: isMobile === false ? "row" : "column",
            width:
              isMobile === false && isOpenContentsModal === false
                ? "100%"
                : "98%",
            minHeight: "170px",
            gap: "10px",
            marginTop: isMobile === false ? "50px" : "20px",
            backgroundColor: "#100F0D",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "70%",
              margin: "20px",
              gap: "20px",
            }}
          >
            <span
              className="textFlex"
              style={{ fontWeight: "600", fontSize: "24px", color: "#EF4536" }}
            >
              {language.value === "tr"
                ? translate("ourTeam").toLocaleUpperCase("tr-TR")
                : translate("ourTeam").toLocaleUpperCase("en-US")}
            </span>
            <span
              className="textFlex"
              style={{ fontWeight: "400", fontSize: "16px", color: "#F2EDED" }}
            >
              {about?.ourTeam.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              maxWidth: isMobile === true && "200px",
              width: isMobile === false ? "30%" : "60%",
              margin: "10px",
              borderRadius: "6px",
              backgroundColor: "#F2F2F2",
              minHeight: isMobile === true && "44px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/crew")}
          >
            <span
              className="textMono"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "700",
                fontSize: "16px",
                gap: "6px",
              }}
            >
              {language.value === "tr"
                ? translate("ourTeam").toLocaleUpperCase("tr-TR")
                : translate("ourTeam").toLocaleUpperCase("en-US")}
              <FaArrowRight
                style={{
                  width: "14px",
                  height: "14px",
                }}
              />
            </span>
          </div>
        </div>
        <div className="aboutUsLeftSubContainer" style={{ marginTop: "60px" }}>
          <div className="aboutUsLeftSubAltContainer">
            <span className="textFlex joinUsTitleStyle">
              {language.value === "tr"
                ? translate("joinUs").toLocaleUpperCase("tr-TR")
                : translate("joinUs").toLocaleUpperCase("en-US")}
            </span>
          </div>
          <span className="textFlex aboutUsDescriptionStyle">
            {about?.joinUs}
          </span>
          <span
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
            className="textFlex aboutUsDescriptionStyle"
            style={{
              width: "100%",
              color: "#EF4536",
              fontStyle: "italic",
              fontWeight: "700",
              cursor: "pointer",
              fontSize: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              marginTop: "20px",
              marginBottom: "20px",
            }}
            onClick={() => {
              alert(`${about?.joinUsEmail} ${translate("copiedToClipboard")}`);
              return navigator.clipboard.writeText(`${about?.joinUsEmail}`);
            }}
          >
            {translate("getInTouch")}
          </span>
          {showTooltip && (
            <div
              style={{
                position: "fixed",
                top: position.y - 50,
                left: position.x - 50,
                backgroundColor: "#333",
                color: "#fff",
                width: "100px",
                height: "100px",
                // padding: "6px 10px",
                borderRadius: "50px",
                pointerEvents: "none",
                zIndex: 99999,
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "25px",
                opacity: "0.7",
              }}
            >
              {translate("email")}
            </div>
          )}
        </div>
      </div>
      {isOpenContentsModal === true && isMobile === false ? (
        <div className="aboutUsRightContainer">
          <div className="aboutUsRightSubContainer">
            <span className="textMono otherContentTextStyle">
              {language.value === "tr"
                ? translate("allContent").toLocaleUpperCase("tr-TR")
                : translate("allContent").toLocaleUpperCase("en-US")}
            </span>
            <hr className="aboutUsRightDivHr" />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              height: "75vh",
              gap: "10px",
            }}
          >
            {contents.map((item) => (
              <ContentCard item={item} isHome={false} key={item.id} />
            ))}
          </div>
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("allContent").toLocaleUpperCase("tr-TR")
                  : translate("allContent").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : isMobile === true && isOpenModal === false ? (
        <div className="aboutUsRightContainer">
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
              onClick={() => setIsOpenModal(true)}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("allContent").toLocaleUpperCase("tr-TR")
                  : translate("allContent").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : (
        isMobile === true && (
          <div className="customModalOverlay">
            <div className="customModalContainer">
              <div
                className="aboutUsRightContainer"
                style={{
                  height: "70vh",
                }}
              >
                <div className="homeRightSubContainer">
                  <span className="textMono allContentTextStyle">
                    {language.value === "tr"
                      ? translate("allContent").toLocaleUpperCase("tr-TR")
                      : translate("allContent").toLocaleUpperCase("en-US")}
                  </span>
                  <hr className="homeRightDivHr" />
                </div>
                <div className="modalScrollableContent">
                  {contents.map((item) => (
                    <ContentCard item={item} key={item.id} />
                  ))}
                </div>

                {isMobile && (
                  <button
                    className="allContentMobileStyle"
                    style={{ textDecoration: "none" }}
                    onClick={() => setIsOpenModal(false)}
                  >
                    <IoCloseOutline
                      style={{ fontSize: "18px", color: "#100F0D" }}
                    />
                    <span className="linkTextStyle textMono">
                      {language.value === "tr"
                        ? translate("allContent").toLocaleUpperCase("tr-TR")
                        : translate("allContent").toLocaleUpperCase("en-US")}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default AboutUs;
